import styled from 'styled-components';
import Image from 'next/image';
import { useTranslate } from 'react-t7e';
import { FC } from 'react';
import { Markdown } from 'vendor/mods/markdown/components/Markdown';
import { media } from 'src/styles/designs';
import { fromTheme, redTheme } from 'src/styles/theme';
import { Theme } from 'vendor/mods/styled-components';
import aboutUsBannerImg from 'src/modules/about-us/assets/banner-image.png';

const Header = styled.h1`
  position: relative;
  z-index: 1;
  font-size: 24px;
  font-weight: 300;
  line-height: 29px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.text.palette.accent};
  max-width: 230px;
  margin-left: max(10vw, 120px);

  ${media.w.greaterThanOrEqual.desktop} {
    max-width: 820px;
    font-size: 50px;
    line-height: 70px;
  }
`;

const Container = styled.div`
  background-color: ${fromTheme((theme) => theme.palette.background)};
  position: relative;
  height: 235px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  ${media.w.greaterThanOrEqual.desktop} {
    height: 400px;
  }
`;

const BannerImage = styled.div`
  position: absolute;
  top: -20px;
  left: -56px;
  width: 261px;
  height: 275px;
  ${media.w.greaterThanOrEqual.desktop} {
    top: -30px;
    left: 0;
    width: 438px;
    height: 462px;
  }
`;

interface AboutUsBannerProps {
  titleMsgId: string;
}

export const AboutUsBanner: FC<AboutUsBannerProps> = ({ titleMsgId }) => {
  const { _ } = useTranslate();

  return (
    <Theme theme={redTheme}>
      <Container>
        <BannerImage>
          <Image
            src={aboutUsBannerImg}
            quality={100}
            objectFit="contain"
            layout="fill"
          />
        </BannerImage>
        <Header>
          <Markdown>{_(titleMsgId)}</Markdown>
        </Header>
      </Container>
    </Theme>
  );
};
